import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#004990',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#80a4c7', // #007f7b, #68b9b7, #118f89
      light: '#f0f7ff'
    },
    warning: {
      main: '#ffd489', // #fff4b0, #ffdf9a
      dark: '#ffc976', // #fff1a0, #ffd788
      text: '#ffbe2c'
    },
    success: {
      main: '#43a047'
    },
    red: {
      main: '#d64242', // #b91919
      dark: '#b72b2b', // #981616
      light: '#ffc1c1'
    },
      //type: 'dark', // Switching the dark mode on is a single property value change.
    background: {
      //default: '#333333'
      default: '#fff'
    }
  },
  typography: {
    fontFamily: 'Roboto',
    useNextVariants: true
  },
  props: {
    MuiTypography: {
      variant: 'body2'
    },
    MuiPaper: {
      elevation: 2
    }
  },
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: 'red',
        '&$error': {
          color: 'red'
        },
      }
    }
  }
});

export default theme;
